import accountDetailsReducer from './accountDetailsReducer';

export default accountDetailsReducer;
